import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useParams, useHistory } from "react-router-dom";
import { Filter } from "chq";
import { Button, Icon } from "@culturehq/components";
import { useInterests, useLocations, useSkills, useDepartments } from "app/context";

import { getFiltersOptions, Trans } from "app/utils";
import FilterGroup, { getTitle } from "components/common/FilterGroup";

import { getPreviousFormPath } from "./eventForms";

// This is pretty flippin hacky, but due to the way that intercom loads its
// stuff through 2 separate iframes, it's pretty difficult to get ahold of it
// through the context of react. In this case, we just need to nudge the
// launcher to be above the footer here. So we're just going to manually do it
// since the launcher isn't even managed through React anyway.
const useNudgeIntercomLauncher = () => useEffect(
  () => {
    const intercom = document.querySelector(".intercom-launcher-frame");

    if (intercom instanceof HTMLIFrameElement) {
      intercom.style.bottom = "92px";

      return () => {
        intercom.style.bottom = "";
      };
    }

    return undefined;
  },
  []
);

type EventFooterProps = {
  setFooterLoaded: (_value: boolean) => void;
  pagination: {
    totalCount: number;
  };
  options: any;
  users: any;
};

const EventFooter: React.FC<EventFooterProps> = ({ setFooterLoaded, pagination, options,
  users }) => {
  useNudgeIntercomLauncher();
  useEffect(() => setFooterLoaded(true), [setFooterLoaded]);

  const { eventForm, eventsId } = useParams();
  const history = useHistory();

  const { skills } = useSkills();
  const { locations } = useLocations();
  const { departments } = useDepartments();
  const { interests } = useInterests();

  const filters: {
    locations: [Filter];
    departments: [Filter];
    interests: [Filter];
    skills: [Filter];
  } = {
    locations: getFiltersOptions("locationIds", locations, options) as [Filter],
    departments: getFiltersOptions("departmentIds", departments, options) as [Filter],
    interests: getFiltersOptions("interestIds", interests, options) as [Filter],
    skills: getFiltersOptions("skillIds", skills, options) as [Filter]
  };

  const usersArray: {
    name: string;
  }[] = users ? Object.values(users) : [];
  const peopleWord = (pagination && pagination.totalCount > 1) ? "people" : "";
  const invitingText = pagination ? `Inviting ${pagination.totalCount} ${peopleWord}` : "";
  const title = `${invitingText}${getTitle(filters.locations, "in")}${getTitle(filters.departments, "in")}${getTitle(filters.interests, "who like")}${getTitle(filters.skills, "skilled in")}`;

  const onBack = () => history.push(getPreviousFormPath(eventForm, eventsId));

  return ReactDOM.createPortal(
    <div className="Welcome__Steps m-steps w-100">
      <div className="row">
        <div className=" Events clearfix text-center">
          <div className="f_section">
            <div className="footer_container">
              <div className="event_footer_left button_container">
                {(eventForm !== "type" && !eventsId) && (
                  <Button primary inverted className="events_btn" onClick={onBack}>
                    <Trans>Back</Trans>
                  </Button>
                )}
              </div>
              { pagination && pagination.totalCount > 1 && (
                <div className="invite_container" title={title}>
                  <Icon className="icon" icon="ios-people" />
                  <p className="invite_legend">
                    {invitingText}
                    <FilterGroup group={filters.locations} prefix="in" />
                    <FilterGroup group={filters.departments} prefix="in" />
                    <FilterGroup group={filters.interests} prefix="who like" />
                    <FilterGroup group={filters.skills} prefix="skilled in" />
                  </p>
                </div>
              )}
              { usersArray.length === 1 && (
                <div className="invite_container" title={title}>
                  <Icon className="icon" icon="ios-people" />
                  <p className="invite_legend">
                    Inviting <strong>{usersArray[0].name}</strong>
                  </p>
                </div>
              )}
              <div id="event_footer_right" className="button_container event_footer_right" />
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EventFooter;
